import React from 'react';
import Icon from '../../../components/AppIcon';

const OverviewMetrics = ({ metrics }) => {
  const colorClasses = {
    blue: 'bg-blue-50 text-blue-600 dark:bg-blue-900/20 dark:text-blue-400',
    green: 'bg-green-50 text-green-600 dark:bg-green-900/20 dark:text-green-400',
    amber: 'bg-amber-50 text-amber-600 dark:bg-amber-900/20 dark:text-amber-400',
    purple: 'bg-purple-50 text-purple-600 dark:bg-purple-900/20 dark:text-purple-400'
  };

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
      {metrics?.map((metric, index) => (
        <div
          key={index}
          className="bg-card rounded-xl p-4 md:p-5 lg:p-6 border border-border shadow-sm hover:shadow-md transition-all duration-250"
        >
          <div className="flex items-start justify-between mb-4">
            <div className={`w-12 h-12 md:w-14 md:h-14 lg:w-16 lg:h-16 rounded-lg ${colorClasses?.[metric?.color]} flex items-center justify-center`}>
              <Icon name={metric?.icon} size={24} className="md:w-7 md:h-7 lg:w-8 lg:h-8" />
            </div>
            {metric?.trend !== undefined && metric?.trend !== 0 && (
              <div className={`flex items-center gap-1 text-xs md:text-sm ${
                metric?.trend > 0 ? 'text-success' : 'text-error'
              }`}>
                <Icon name={metric?.trend > 0 ? 'TrendingUp' : 'TrendingDown'} size={16} />
                <span>{Math.abs(metric?.trend)}%</span>
              </div>
            )}
          </div>
          <div>
            <h3 className="text-sm md:text-base text-muted-foreground mb-1">{metric?.title}</h3>
            <p className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground mb-1">{metric?.value}</p>
            {metric?.subtitle && (
              <p className="text-xs md:text-sm text-muted-foreground">{metric?.subtitle}</p>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default OverviewMetrics;